import { Button, Dialog, DialogActions, DialogProps, DialogTitle, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { BusinessOrderInfo, CustomerOrderInfo, FlightInfo, OrderInfo } from 'adoms-common-lib';
import React, { useEffect } from 'react';
import { APIConnector } from "../../connector/APIConnector";
import FlightOrderCombinationDialogContent from '../molecule/FlightOrderCombinationDialogContent';
import { LoadingMark } from '../atoms/LoadingMark';

const useStyles = makeStyles()((theme: any) => ({
    root: {
        display: 'flex',
        backgroundColor: theme.palette.background.default,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },


    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },

    selectEmpty: {
        marginTop: theme.spacing(2),
    },

    deliveryTable: {
        minWidth: 1024,
    },

    flightInfoInputTable: {
        minWidth: 512,
    },

    newButton: {
        position: 'fixed',
        top: theme.spacing(9),
        right: theme.spacing(3),
    },

    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },


    select: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },

    stepper: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,

    },
    table: {
        minWidth: 100,
    },
}));



type FlightOrderCombinationDialogForFlightDetailProps = {
    /**
     * 配送依頼を紐付けるフライト
     */
    flight: FlightInfo,
    /**
     * ダイアログがオープンしているかどうか
     */
    isOpen: boolean,
    /**
     * ダイアログをクローズする際のハンドラ
     */
    onClose: (event: any) => void,
    onAddOrder: (order: OrderInfo | undefined) => void,
    addedOrder: OrderInfo[],
}

const FlightOrderCombinationDialogForFlightDetail: React.FC<FlightOrderCombinationDialogForFlightDetailProps> = (props) => {
    const { classes } = useStyles();
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('body');
    const [isLoding, setIsLoading] = React.useState(true);
    const [errorFlag, setErrorFlag] = React.useState(false);
    const flight = props.flight as FlightInfo;
    const [orderList, setOrderList] = React.useState<OrderInfo[]>([]);
    const [selectedOrder, setSelectedOrder] = React.useState("");
    const order = orderList.find((v) => v.orderID === selectedOrder) as OrderInfo;
    const [isButtonDisable, setButtonDisable] = React.useState(true);

    useEffect(() => {
        const fetchData = async () => {
            let c: APIConnector = APIConnector.instance;
            setIsLoading(true);
            /**
             * 配送依頼一覧を取得
             */
            const currentFlight: Promise<OrderInfo[]> = c.getOrderListForNoAssignedFlight()
            let allorderList = [] as OrderInfo[];
            await currentFlight.then((value: any) => {
                allorderList = value as OrderInfo[];
            }).catch((error: any) => {
                //エラーフラグをtrueにしこの関数の処理を終了する
                setErrorFlag(true);
                setIsLoading(false);
                return;
            });

            /**
             * 発着地に合う配送依頼のみのオーダーだけ取得
             */
            let filteredOrderList = allorderList.filter(
                (v) => (v.departure.id === flight.departure.id &&
                    v.arrival.id === flight.arrival.id
                )
            );

            /**
            * addedOrderに格納され、選択済みのものはリストから外す
            */
            filteredOrderList = filteredOrderList.filter(
                (v) => !props.addedOrder.some(
                    (v2) => v2.orderID === v.orderID
                )
            );

            setOrderList(filteredOrderList);
            setErrorFlag(false);
            setIsLoading(false);
        }
        fetchData();
    }, [props.isOpen]);

    /**
     * ダイアログをクローズする
     */
    const handleDialogClose = (event: any) => {
        props.onClose(event);
    };

    const handleChangeOrder = (event: any) => {
        setSelectedOrder(event.target.value);
        setButtonDisable(false);
    }

    const handleAddOrder = (event: React.MouseEvent<HTMLButtonElement>) => {
        props.onAddOrder(order);
        props.onClose(event);
        setSelectedOrder("");
        setButtonDisable(true);
        //fetchData();
    }

    return (
        <div className={classes.root}>
            {/** フライト新規作成ダイアログ */}
            <Dialog
                open={props.isOpen}
                onClose={handleDialogClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                style={{ zIndex: 1100 }}
            >
                <DialogTitle id="scroll-dialog-title">配送依頼選択<Divider /></DialogTitle>
                {isLoding ? (
                    <LoadingMark isDisplayLoadingMark={isLoding} />
                ) : (
                    <FlightOrderCombinationDialogContent
                        flight={flight}
                        isOpen={props.isOpen}
                        orderList={orderList}
                        isErrorFlag={errorFlag}
                        handleChangeOrder={handleChangeOrder}
                        setSelectedOrder={setSelectedOrder}
                        selectedOrder={selectedOrder}
                        addedOrder={props.addedOrder}
                    />
                )}
                <DialogActions>
                    <Button color="primary" onClick={handleAddOrder} disabled={isButtonDisable}>
                        選択
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default FlightOrderCombinationDialogForFlightDetail;